<template>
  <div :class="$style.accordion">
    <div :class="$style.accordion__question" @click="toggle">
      <div :class="$style.accordion__title">
        <slot name="title" />
      </div>
      <div
        :class="[
          $style.accordion__icon,
          { [$style['accordion__icon--opened']]: isOpen },
        ]"
      >
        <IconChevron />
      </div>
    </div>
    <SlideTransition @afterLeave="afterLeave">
      <div v-show="isOpen" :class="$style.accordion__content">
        <slot name="content" :isShown="isShown" />
      </div>
    </SlideTransition>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import IconChevron from '@/components/icons/IconChevron.vue'
import SlideTransition from '@/components/transitions/SlideTransition.vue'

const isOpen = ref(false)

// isOpenのタイミングでcontentをv-ifでだし分けると、閉じる時に
// 急に高さがなくなるのでTransitonがうまく効かなくなる
// 閉じる際はTranstionが終わったら閉じる
const isShown = ref(false)

const afterLeave = () => {
  isShown.value = false
}

const toggle = () => {
  isOpen.value = !isOpen.value

  if (isOpen.value) {
    isShown.value = true
  }
}
</script>

<style lang="scss" module>
.accordion {
  $padding-left-right: 16px;

  padding: 20px $padding-left-right;
  background-color: $color-surface-primary;

  &__question {
    display: flex;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    position: relative;
    gap: 8px;
  }

  &__title {
    font-size: 16px;
    flex: 1;
  }

  &__icon {
    width: 30px;
    height: 30px;

    &--opened {
      background-color: $color-surface-secondary;
      border-radius: 50%;
      transform: rotate(180deg);
    }

    & > * {
      width: 100%;
      height: 100%;
    }
  }

  &__content {
    margin-top: 20px;
  }
}
</style>
